import React from 'react';
import { HeroVariant45 } from '../components/HeroVariant45';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage45() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1679">
      {/* Navigation is intentionally omitted here because it is built into HeroVariant45 */}
      <main data-id="element-1680">
        <HeroVariant45 data-id="element-1681" />
        <WhyUs data-id="element-1682" />
        <Services data-id="element-1683" />
        <FAQ data-id="element-1684" />
        <Testimonials data-id="element-1685" />
        <Consultation data-id="element-1686" />
      </main>
      <Footer data-id="element-1687" />
      <CookieBanner data-id="element-1688" />
      <FloatingContact data-id="element-1689" />
    </div>;
}